/**
 * Token de inyección para UserRepository
 */

import { InjectionToken } from '@angular/core';
import { UserRepository } from './user.repository';

export const USER_REPOSITORY_TOKEN = new InjectionToken<UserRepository>('UserRepository');

